











































































































































































































import { Component, Vue } from 'vue-property-decorator'
import ExpandIcon from '@/app/ui/assets/expand_icon.vue'
import CloseIcon from '@/app/ui/assets/ics_o_close_white.vue'
import MainController from '@/app/ui/controllers/MainController'
import { Utils } from '@/app/infrastructures/misc'
import { Report } from '@/domain/entities/Main'
import Teleport from '../Teleport/index.vue'

@Component({
  components: {
    ExpandIcon,
    CloseIcon,
    Teleport
  },
})
export default class WidgetDownload extends Vue {
  private requestInInterval: number | undefined

  beforeDestroy() {
    clearInterval(this.requestInInterval as number)
    MainController.setOpenWidgetDownload(false)
    MainController.setHideWidgetDownload(true)
  }

  async mounted() {
    MainController.reportData.pagination.perPage = 10
    this.initiateInfiniteScroll()
    this.initiateGetListDownloadReport()
  }

  getReportList() {
    MainController.getReportList()
  }
  initiateGetListDownloadReport() {
    this.getReportList()
  }

  initiateInfiniteScroll() {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const {
          pagination: { total },
          data,
        } = MainController.reportData

        const getInfinite = !total || data?.length < total

        if (entry.isIntersecting && getInfinite) {
          MainController.reportData.pagination.perPage += 10
          this.getReportList()
        }
      })
    }, {})

    const element: any = document.querySelector('#infinite-scroll')
    observer.observe(element)
  }

  get reports(): Report[][] {
    return MainController.reportData.renderedList
  }

  get loading(): boolean {
    return MainController.loadingExport
  }

  get findWaitingAndToday() {
    const checkWaitingAndToday = MainController.reportData.data.findIndex((data: Report) => {
      return (
        data.status === 'waiting' &&
        new Date(data.createdAt).getDate() === new Date().getDate()
      )
    })
    return checkWaitingAndToday > -1
  }
  
  get maxHeight(): string {
    if (this.openWidgetDownload) return "450px";
    return "0px";
  }

  private setOpenWidgetDownload() {
    MainController.setOpenWidgetDownload(!this.openWidgetDownload);
  }
  
  closeWidgetDownload(): void {
    MainController.setHideWidgetDownload(true);
  }

  tooltip = false
  tooltipId = 0
  openTooltip(value: boolean, id = 0) {
    this.tooltipId = id
    this.tooltip = value
  }

  sleep(time: number) {
    return new Promise(resolve => setTimeout(resolve, time))
  }

  async onDownload(item: any) {
    const files = item.url.split(',')
    for (const file of files) {
      if (file) {
        Utils.directDownloadFile(file)
        await this.sleep(500)
      }
    }
  }

  get openWidgetDownload(): boolean {
    return MainController.openWidgetDownload
  }

  get hideWidgetDownload(): boolean {
    return MainController.hideWidgetDownload
  }
}
